import { AU1_PRODUCTION_HOSTS } from '@fleet/environment';
import { FLEET_VERSION } from '@fleet/version';

export const environment = {
  production: true,
  hmr: false,
  version: FLEET_VERSION,
  minTokenExpiry: 60,
  fleetProduct: 'TRAVELLER',
  envName: 'prod-au1',

  ...AU1_PRODUCTION_HOSTS,
};
